export function getConfirmRequestsByRequestDate(requestsToConfirm, date) {
  return requestsToConfirm.filter((confirmRequest) => confirmRequest?.get('request')?.get('requestFrom') <= date);
}
